import { IUploadFilesState } from './upload-files.state';
import { createReducer, on } from '@ngrx/store';
import {
  loadDocumentTypes,
  loadDocumentTypesFailure,
  loadDocumentTypesSuccess,
} from './upload-files.actions';

export const initialState: IUploadFilesState = {
  documentTypes: [],
  loading: false,
  error: null,
};
export const uploadFilesReducer = createReducer(
  initialState,
  on(loadDocumentTypes, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(loadDocumentTypesSuccess, (state, { documentTypes }) => {
    return {
      ...state,
      documentTypes,
      loading: false,
    };
  }),
  on(loadDocumentTypesFailure, (state) => {
    return {
      ...state,
      loading: false,
    };
  })
);
